import React from "react";
import Input from "./Input";
import validation from "./Validation";
import { LuCalendar } from "react-icons/lu";
import Calendar from 'react-calendar';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { ValidatorType } from "../../types-interfaces/types";

interface InputFechaProps extends React.InputHTMLAttributes<HTMLInputElement>{
  onClickDay?: (value: Date, event: React.MouseEvent<HTMLButtonElement>) => void;
  calendarhidden?: boolean | undefined;
  calendarmaxdate?: Date | undefined;
  calendarmindate?: Date | undefined;
  error?: string;
  label?: string;
  formatlabel?: string;
  validators?: ValidatorType[];
  columns?: "col-3" | undefined;
};

class InputOut extends React.Component<InputFechaProps>{  
  render(){    
    return(
      <div className={this.props.className + ' ' +  (this.props.columns || '')}>
        <LuCalendar
          className={this.props.className + '-icon'}          
        />
        <Input
          className={this.props.className}
          type="text"
          value={this.props.value}
          error={this.props.error}
          label={this.props.label}
          formatlabel={this.props.formatlabel}          
          onClick={this.props.onClick}
          onMouseOver={this.props.onMouseOver}
          validators={this.props.validators}
          alt={this.props.alt}
          onChange={this.props.onChange}
        />
        {
          !this.props.calendarhidden &&
          <div data-testid="calendar">
            <Calendar
              className={this.props.className + '-calendar'}
              minDate={this.props.calendarmindate}
              maxDate={this.props.calendarmaxdate}            
              onClickDay={this.props.onClickDay}            
              maxDetail="month"
            />
          </div>
        }
      </div>
    );
  }

}

const InputFecha = validation(InputOut);

export default InputFecha;